import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  alpha
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PronunciationSection from './PronunciationSection';
import HomophonesSection from './HomophonesSection';

const WordDetails = ({ wordData }) => {
  const theme = useTheme();

  if (!wordData) return null;

  return (
    <Card 
      variant="outlined" 
      className="card-fade-in"
      sx={{ 
        mb: 3, 
        bgcolor: theme.palette.background.paper,
        borderColor: alpha(theme.palette.common.white, 0.1)
      }}
    >
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="h5" color="text.primary">
                {wordData.word}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12}>
            <Divider sx={{ borderColor: alpha(theme.palette.common.white, 0.1) }} />
          </Grid>
          
          <PronunciationSection homographs={wordData.homographs} />
          
          <HomophonesSection homophones={wordData.homophones} />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default WordDetails;